import auth from '../../../modules/auth'
import { LOGOUT } from '../../../modules/actions'

export const logout = () => ({
  type: LOGOUT
})

export const handleLogout = (history) => {
  return async (dispatch , getState) => {
    let signup = getState().signup
    await auth.logout()
    dispatch(logout())
    if(signup.campaign === 'AFLAC') {
      window.location.href="/customer/login"
    } else {
      history.push('/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/logout/modules/logout.js